import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './ui/CTAButton';
export function HeroSection() {
  return <section className="relative pt-16 pb-10 px-4 md:px-8 overflow-hidden min-h-[90vh] flex items-center" data-id="element-58">
      {/* Background Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-radial-cyan opacity-60 pointer-events-none" data-id="element-59" />

      <div className="max-w-6xl mx-auto w-full relative z-10 grid lg:grid-cols-2 gap-12 items-center" data-id="element-60">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="text-center lg:text-left" data-id="element-61">
          <div className="inline-block px-4 py-1.5 rounded-full bg-cyan-500/10 border border-cyan-500/20 text-cyan-400 text-sm font-semibold mb-6 tracking-wide" data-id="element-62">
            EL PROTOCOLO BIOLÓGICO
          </div>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6" data-id="element-63">
            Deja de "intentar" dormir: El Protocolo Biológico para recuperar{' '}
            <span className="font-extrabold" data-id="element-64">8 horas de sueño profundo</span>{' '}
            (sin pastillas ni resaca).
          </h1>
          <h2 className="text-lg md:text-xl text-[#b8c4d6] mb-10 leading-relaxed max-w-2xl mx-auto lg:mx-0 font-sans font-normal" data-id="element-65">
            La guía definitiva para apagar el cerebro, eliminar el cortisol
            nocturno y despertar con energía real, basada en la ciencia de la
            arquitectura térmica y lumínica.
          </h2>

          <CTAButton text="DESCUBRE AHORA" href="#oferta" data-id="element-66" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="relative mx-auto w-full max-w-md lg:max-w-full" data-id="element-67">
          <div className="absolute inset-0 bg-cyan-500/15 blur-[100px] rounded-full" data-id="element-68" />
          <img src="https://cdn.magicpatterns.com/uploads/3q5xfZZMKHm7tyiT75L2ZH/grok-image-4b2b4708-b74a-4eb6-b258-7a30fd801c8c.png" alt="El Código del Sueño Profundo" className="relative z-10 w-full h-auto drop-shadow-2xl" data-id="element-69" />
        </motion.div>
      </div>
    </section>;
}